import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import Button from '~/components/Button';

function InputDropzoneFile(props) {
  const { onChange, disabled, accept, text, style } = props;

  const onDrop = useCallback((acceptedFiles) => {
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => console.log('file reading has failed');

    acceptedFiles.map((file) => {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
    });
    onChange(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
  });

  return (
    <Button color="blue" disabled={disabled} style={style} {...getRootProps()}>
      <input {...getInputProps()} />
      <p style={{ margin: 0 }}>{text ?? 'INSERIR ANEXO'}</p>
    </Button>
  );
}

export default InputDropzoneFile;
